const CreditStatus = Object.freeze({
  CERRADO: 10,
  DISPERSION_PENDIENTE: 20,
  ETAPA_1: 30,
  ETAPA_2: 40,
  ETAPA_3: 50,
  RENEGOCIADO: 60,
  CANCELADO: 70
})

module.exports = CreditStatus
